module.exports = angular.module('cartographer.plugin.layer.wrt', [])

_ = require 'underscore'

module.exports.run $DI (
  crtLayer
  wrtFordsLayer
  wrtUpstreamThinkingLayer
  wrtWestcountryCsiLayer
) ->
  crtLayer.registerPlugin(wrtFordsLayer)
  crtLayer.registerPlugin(wrtUpstreamThinkingLayer)
  crtLayer.registerPlugin(wrtWestcountryCsiLayer)
  return

module.exports.factory "wrtUpstreamThinkingLayer", $DI (
  crtMarkerColor
  crtFeatureLayer
  crtAttributeLayer
  crtMapCollaborationModel
  crtMapPermissionModel
) ->
  crtFeatureLayer.create({
    id: "wrtUpstreamThinking"
    name: "Upstream Thinking"
    atlasMapId: "wrtUpstreamThinking"
    defaultMapEngine: "atlas"
    selectionRadius: 500
    attributeGroups: [
      crtFeatureLayer.createAttributeGroup("wrtUpstreamThinking", "Data Attributes", [
        crtAttributeLayer.createAutoThreshold("flow", "Estimated flow", "m3/s")
        crtAttributeLayer.createRange("temperature", "Temperature", "C", [
          { minValue: null , maxValue:    4 , color: crtMarkerColor.create("#2e3090") }
          { minValue:    4 , maxValue:    8 , color: crtMarkerColor.create("#0865b1") }
          { minValue:    8 , maxValue:   12 , color: crtMarkerColor.create("#1094d8") }
          { minValue:   12 , maxValue:   16 , color: crtMarkerColor.create("#15a9c2") }
          { minValue:   16 , maxValue:   20 , color: crtMarkerColor.create("#ea8133") }
          { minValue:   20 , maxValue: null , color: crtMarkerColor.create("#be2432") }
        ])
        # crtAttributeLayer.createThreshold("ph", "pH", null, [
        #   { value:  1 , color: crtMarkerColor.ph(1)  , label: "1"  }
        #   { value:  2 , color: crtMarkerColor.ph(2)  , label: "2"  }
        #   { value:  3 , color: crtMarkerColor.ph(3)  , label: "3"  }
        #   { value:  4 , color: crtMarkerColor.ph(4)  , label: "4"  }
        #   { value:  5 , color: crtMarkerColor.ph(5)  , label: "5"  }
        #   { value:  6 , color: crtMarkerColor.ph(6)  , label: "6"  }
        #   { value:  7 , color: crtMarkerColor.ph(7)  , label: "7"  }
        #   { value:  8 , color: crtMarkerColor.ph(8)  , label: "8"  }
        #   { value:  9 , color: crtMarkerColor.ph(9)  , label: "9"  }
        #   { value: 10 , color: crtMarkerColor.ph(10) , label: "10" }
        #   { value: 11 , color: crtMarkerColor.ph(11) , label: "11" }
        #   { value: 12 , color: crtMarkerColor.ph(12) , label: "12" }
        #   { value: 13 , color: crtMarkerColor.ph(13) , label: "13" }
        #   { value: 14 , color: crtMarkerColor.ph(14) , label: "14" }
        # ])
        crtAttributeLayer.createAutoThreshold("ph"                            , "pH")
        crtAttributeLayer.createAutoThreshold("electricalConductivity"        , "Electrical conductivity"          , "Âµs/cm")
        crtAttributeLayer.createAutoThreshold("turbidity"                     , "Turbidity"                        , "FAU")
        crtAttributeLayer.createAutoThreshold("suspendedSediment"             , "Suspended sediment"               , "mg/l")
        crtAttributeLayer.createAutoThreshold("color"                         , "Colour"                           , "Hazen")
        crtAttributeLayer.createRange("totalDissolvedSolids", "Total dissolved solids", "mg/l", [
          { minValue: null , maxValue:   50 , color: crtMarkerColor.create("hsl(120, 80%, 70%)") }
          { minValue:   50 , maxValue:  200 , color: crtMarkerColor.create("hsl(120, 80%, 58%)") }
          { minValue:  200 , maxValue:  350 , color: crtMarkerColor.create("hsl(120, 80%, 48%)") }
          { minValue:  350 , maxValue:  500 , color: crtMarkerColor.create("hsl(120, 80%, 40%)") }
          { minValue:  500 , maxValue:  650 , color: crtMarkerColor.create("hsl(120, 80%, 32%)") }
          { minValue:  650 , maxValue:  800 , color: crtMarkerColor.create("hsl(120, 80%, 22%)") }
          { minValue:  800 , maxValue: null , color: crtMarkerColor.create("hsl(120, 80%, 10%)") }
        ])
        crtAttributeLayer.createAutoThreshold("tryptophan"                    , "Tryptophan"                       , "counts")
        crtAttributeLayer.createAutoThreshold("phosphate"                     , "Phosphates"                       , "mg/l")
        crtAttributeLayer.createAutoThreshold("dissolvedOxygenSaturation"     , "Dissolved oxygen saturation"      , "%")
        crtAttributeLayer.createAutoThreshold("dissolvedOxygenConcentration"  , "Dissolved oxygen concentration"   , "mg/l")
        crtAttributeLayer.createAutoThreshold("coloredDissolvedOrganicMatter" , "Colored dissolved organic matter" , "counts")
        crtAttributeLayer.createAutoThreshold("opticalBrighteningAgents"      , "Optical brightening agents"       , "counts")
      ])
    ]
  })

module.exports.factory "wrtWestcountryCsiLayer", $DI (
  crtFeatureLayer
  crtAttributeLayer
  crtMarkerColor
  crtMapCollaborationModel
  crtMapPermissionModel
  wrtRainfall
  wrtWestcountryCsiWaterBodyType
  wrtWestcountryCsiLandUse
  wrtWestcountryCsiBankVegetation
  wrtWestcountryCsiInvasivePlant
  wrtWestcountryCsiWildlife
  wrtWestcountryCsiPollutionSource
  wrtWestcountryCsiPollutionEvidence
  wrtWestcountryCsiWaterLevel
  wrtWestcountryCsiChannelSubstrate
) ->
  crtFeatureLayer.create({
    id: "wrtWestcountryCsi"
    name: "Westcountry CSI"
    atlasMapId: "wrtWestcountryCsi"
    defaultMapEngine: "atlas"
    selectionRadius: 500
    attributeGroups: [
      crtFeatureLayer.createAttributeGroup("plantsAndWildlife", "Plants and wildlife", [
        # crtAttributeLayer.createEnumLookup( "landUse"                 , "Land Use"                     , null , wrtWestcountryCsiLandUse)
        # crtAttributeLayer.createEnumLookup( "bankVegetation"          , "Vegetation cover"             , null , wrtWestcountryCsiBankVegetation)
        crtAttributeLayer.createEnumLookup("invasivePlant", "Invasive plants", null, wrtWestcountryCsiInvasivePlant)
        crtAttributeLayer.createEnumLookup("wildlife", "Wildlife", null, wrtWestcountryCsiWildlife)
        crtAttributeLayer.createLookup("outfalls", "Outfall(s)", null, [
          { value: null       , label: "None recorded"             , color: crtMarkerColor.create("#fff") }
          { value: "Active"   , label: "Active (discharging)"      , color: crtMarkerColor.create("rgb(255, 128, 0)") }
          { value: "Inactive" , label: "Dormant (not discharging)" , color: crtMarkerColor.create("rgb(255, 255, 0)") }
        ])
      ])
      crtFeatureLayer.createAttributeGroup("pollution", "Pollution", [
        crtAttributeLayer.createEnumLookup("pollutionSource", "Visible sources of pollution", null, wrtWestcountryCsiPollutionSource)
        crtAttributeLayer.createEnumLookup("pollutionEvidence", "Evidence of recent pollution", null, wrtWestcountryCsiPollutionEvidence)
      ])
      crtFeatureLayer.createAttributeGroup("riverChannel", "River channel observations", [
        crtAttributeLayer.createRange("temperature", "Temperature", "C", [
          { minValue: null , maxValue:    4 , color: crtMarkerColor.create("#1094d8") }
          { minValue:    4 , maxValue:    8 , color: crtMarkerColor.quality(.9) }
          { minValue:    8 , maxValue:   12 , color: crtMarkerColor.quality(.5) }
          { minValue:   12 , maxValue:   16 , color: crtMarkerColor.quality(.4) }
          { minValue:   16 , maxValue:   20 , color: crtMarkerColor.quality(.3) }
          { minValue:   20 , maxValue:   24 , color: crtMarkerColor.quality(.2) }
          { minValue:   24 , maxValue: null , color: crtMarkerColor.quality(.1) }
        ])
        crtAttributeLayer.createRange("totalDissolvedSolids", "Total dissolved solids", "ppm", [
          { minValue: null , maxValue:   50 , color: crtMarkerColor.create("#1094d8") }
          { minValue:   50 , maxValue:  200 , color: crtMarkerColor.quality(.9) }
          { minValue:  200 , maxValue:  350 , color: crtMarkerColor.quality(.5) }
          { minValue:  350 , maxValue:  500 , color: crtMarkerColor.quality(.4) }
          { minValue:  500 , maxValue:  650 , color: crtMarkerColor.quality(.3) }
          { minValue:  650 , maxValue:  800 , color: crtMarkerColor.quality(.2) }
          { minValue:  800 , maxValue: null , color: crtMarkerColor.quality(.1) }
        ])
        crtAttributeLayer.createRange("turbidity", "Turbidity", "NTU", [
          { minValue: null , maxValue:   12 , color: crtMarkerColor.create("#1094d8") }
          { minValue:   12 , maxValue:   40 , color: crtMarkerColor.quality(.9) }
          { minValue:   40 , maxValue:   80 , color: crtMarkerColor.quality(.5) }
          { minValue:   80 , maxValue:  120 , color: crtMarkerColor.quality(.4) }
          { minValue:  120 , maxValue:  160 , color: crtMarkerColor.quality(.3) }
          { minValue:  160 , maxValue:  240 , color: crtMarkerColor.quality(.2) }
          { minValue:  240 , maxValue: null , color: crtMarkerColor.quality(.1) }
        ])
        crtAttributeLayer.createRange("phosphate", "Phosphates", "ppb", [
          { minValue: null , maxValue:  100 , color: crtMarkerColor.create("#1094d8") }
          { minValue:  100 , maxValue:  200 , color: crtMarkerColor.quality(.9) }
          { minValue:  200 , maxValue:  300 , color: crtMarkerColor.quality(.5) }
          { minValue:  300 , maxValue:  500 , color: crtMarkerColor.quality(.4) }
          { minValue:  500 , maxValue: 1000 , color: crtMarkerColor.quality(.3) }
          { minValue: 1000 , maxValue: 2500 , color: crtMarkerColor.quality(.2) }
          { minValue: 2500 , maxValue: null , color: crtMarkerColor.quality(.1) }
        ])
        crtAttributeLayer.createEnumLookup( "predominateSubstrate" , "Predominant substrate" , null , wrtWestcountryCsiChannelSubstrate)
      ])
      crtFeatureLayer.createAttributeGroup("optionalRiverChannel", "Optional river channel observations", [
        crtAttributeLayer.createAutoThreshold("ph", "pH")
        crtAttributeLayer.createAutoThreshold("bacteria", "Bacteria")
        crtAttributeLayer.createAutoThreshold("nitrate", "Nitrate")
        crtAttributeLayer.createAutoThreshold("ammonia", "Ammonia")
      ])
    ]
  })

module.exports.factory "wrtFordsLayer", $DI (
  crtFeatureLayer
  crtAttributeLayer
  crtMarkerColor
  crtMapCollaborationModel
  crtMapPermissionModel
  wrtRainfall
  wrtLandUse
  wrtFlowLevel
  wrtFordsPhosphate
  wrtFordsNitrate
  wrtFordsAmmonia
) ->
  crtFeatureLayer.create({
    id: "wrtFords"
    name: "FORDs"
    atlasMapId: "wrtFords"
    defaultMapEngine: "atlas"
    selectionRadius: 500
    attributeGroups: [
      crtFeatureLayer.createAttributeGroup("wrtFords", "Data Attributes", [
        crtAttributeLayer.createLookup("rainfall", "Rainfall (past 24h)", null, [
          { value: wrtRainfall.None  , color: crtMarkerColor.create("#0099ff") , label: wrtRainfall.valueName(wrtRainfall.None)  }
          { value: wrtRainfall.Light , color: crtMarkerColor.create("#0066bb") , label: wrtRainfall.valueName(wrtRainfall.Light) }
          { value: wrtRainfall.Heavy , color: crtMarkerColor.create("#003366") , label: wrtRainfall.valueName(wrtRainfall.Heavy) }
        ])
        crtAttributeLayer.createEnumLookup("landUse"  , "Land use" , null , wrtLandUse)
        crtAttributeLayer.createLookup("flow", "Flow", null, [
          { value: wrtFlowLevel.Still   , color: crtMarkerColor.create("#0099ff") , label: wrtFlowLevel.valueName(wrtFlowLevel.Still)   }
          { value: wrtFlowLevel.Slow    , color: crtMarkerColor.create("#0077cc") , label: wrtFlowLevel.valueName(wrtFlowLevel.Slow)    }
          { value: wrtFlowLevel.Steady  , color: crtMarkerColor.create("#005599") , label: wrtFlowLevel.valueName(wrtFlowLevel.Steady)  }
          { value: wrtFlowLevel.Surging , color: crtMarkerColor.create("#003366") , label: wrtFlowLevel.valueName(wrtFlowLevel.Surging) }
        ])
        crtAttributeLayer.createRange("totalDissolvedSolids", "Total dissolved solids", "ppm", [
          { minValue: null , maxValue:  100 , color: crtMarkerColor.create("#ccc") , label: "<100"      }
          { minValue:  100 , maxValue:  200 , color: crtMarkerColor.create("#bbb") , label: "100-200"   }
          { minValue:  200 , maxValue:  300 , color: crtMarkerColor.create("#aaa") , label: "200-300"   }
          { minValue:  300 , maxValue:  500 , color: crtMarkerColor.create("#999") , label: "300-500"   }
          { minValue:  500 , maxValue: 1000 , color: crtMarkerColor.create("#888") , label: "500-1000"  }
          { minValue: 1000 , maxValue: 1500 , color: crtMarkerColor.create("#777") , label: "1000-1500" }
          { minValue: 1500 , maxValue: null , color: crtMarkerColor.create("#666") , label: ">1500"     }
        ])
        crtAttributeLayer.createRange("turbidity", "Turbidity", "NTU", [
          { minValue: null , maxValue: 12   , color: crtMarkerColor.create("#00acec") , label: "<12"     }
          { minValue: 12   , maxValue: 25   , color: crtMarkerColor.create("#00aad0") , label: "12-25"   }
          { minValue: 25   , maxValue: 30   , color: crtMarkerColor.create("#66a6a2") , label: "25-30"   }
          { minValue: 30   , maxValue: 40   , color: crtMarkerColor.create("#a9a178") , label: "30-40"   }
          { minValue: 40   , maxValue: 50   , color: crtMarkerColor.create("#dd9948") , label: "40-50"   }
          { minValue: 50   , maxValue: 75   , color: crtMarkerColor.create("#f69532") , label: "50-75"   }
          { minValue: 75   , maxValue: 150  , color: crtMarkerColor.create("#cf8033") , label: "75-150"  }
          { minValue: 150  , maxValue: 240  , color: crtMarkerColor.create("#a26730") , label: "150-240" }
          { minValue: 240  , maxValue: null , color: crtMarkerColor.create("#754d2c") , label: ">240"    }
        ])
        crtAttributeLayer.createRange("phosphate", "Phosphate", "ppb" , [
          { minValue:    0 , maxValue:   99 , color: crtMarkerColor.create("#d0d0c5") , label: "0"    }
          { minValue:  100 , maxValue:  199 , color: crtMarkerColor.create("#a5b5ab") , label: "100"  }
          { minValue:  200 , maxValue:  299 , color: crtMarkerColor.create("#7a9797") , label: "200"  }
          { minValue:  300 , maxValue:  499 , color: crtMarkerColor.create("#5b8794") , label: "300"  }
          { minValue:  500 , maxValue:  999 , color: crtMarkerColor.create("#446a85") , label: "500"  }
          { minValue: 1000 , maxValue: 2499 , color: crtMarkerColor.create("#224b74") , label: "1000" }
          { minValue: 2500 , maxValue: null , color: crtMarkerColor.create("#123164") , label: "2500" }
        ])
        crtAttributeLayer.createRange("nitrate", "Nitrate", "ppm" , [
          { minValue:   0 , maxValue:    9 , color: crtMarkerColor.create("#d2cac7") , label: "0"   }
          { minValue:  10 , maxValue:   29 , color: crtMarkerColor.create("#d1beb7") , label: "10"  }
          { minValue:  30 , maxValue:   59 , color: crtMarkerColor.create("#cfaaa7") , label: "30"  }
          { minValue:  60 , maxValue:  119 , color: crtMarkerColor.create("#c98f93") , label: "60"  }
          { minValue: 120 , maxValue:  199 , color: crtMarkerColor.create("#c5677c") , label: "120" }
          { minValue: 200 , maxValue: null , color: crtMarkerColor.create("#c15c6d") , label: "200" }
        ])
        crtAttributeLayer.createRange("ammonia", "Ammonia", "ppm" , [
          { minValue:   0 , maxValue: 0.49 , color: crtMarkerColor.create("#d9cf81") , label: "0"   }
          { minValue: 0.5 , maxValue: 0.99 , color: crtMarkerColor.create("#d1ca6d") , label: "0.5" }
          { minValue: 1.0 , maxValue: 2.99 , color: crtMarkerColor.create("#c2c489") , label: "1.0" }
          { minValue: 3.0 , maxValue: 5.99 , color: crtMarkerColor.create("#9bb384") , label: "3.0" }
          { minValue: 6.0 , maxValue: null , color: crtMarkerColor.create("#6a9685") , label: "6.0" }
        ])
      ])
    ]
  })
